import React from 'react';
import './EnvRibbon.css';
import { returnCurrentEnv } from '@/consts';

const env = `${returnCurrentEnv()}`;

interface IEnvRibbonProps {
  type?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
}


// TODO - copied from MMM, move to shared
export default function EnvRibbon({ type = 'top-left' }: IEnvRibbonProps) {
  if (env !== 'prd') {
    return (
      <div className={`ribbon ribbon-${type}`}>
        <span>{env.toUpperCase()}</span>
      </div>
    );
  }
  return null;
}
